var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCabinBaggage = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M12.8 25.944h-2.667c-.294 0-.533-.322-.533-.72V13.72c0-.397.239-.719.533-.719h11.734c.294 0 .533.322.533.72v11.505c0 .397-.239.719-.533.719H19.2m-6.4 0V27.4m0-1.456h6.4m0 0V27.4m0-14.6V3.912c0-.189-.135-.37-.375-.503-.24-.134-.566-.209-.905-.209h-3.84c-.34 0-.665.075-.905.209-.24.133-.375.314-.375.503V12.8"
})));
export { SvgCabinBaggage as ReactComponent };